import React from "react";
import {CommonUtil} from "../../utils/CommonUtil";

const ReservationIdCellRenderer = (props:any)=>{
    const onClickLink = ()=>{
        if(props.context && props.data.reservationId){
            localStorage.setItem("ReservationTab","true");
            let siteOrigin:string = window.location.origin;
            siteOrigin = siteOrigin+"/?requestor=reservationview&reservationId="+props.data.reservationId+"&token="+ localStorage.getItem("token");
            
            var newTab = document.createElement('a');
            newTab.href = siteOrigin;
            newTab.setAttribute('target', '_blank');
            newTab.click();
        }
    }
    return(
        <div className={"cellRenderHeader"}>
            {props.data.reservationId ? (
                <a><span onClick={onClickLink} className={"cellRender"}>{props.data.reservationCode}</span></a>
            ) : null}
        </div>
    )
}

export default ReservationIdCellRenderer;